import axiosInstance from "../axios/axiosInstance";
import ENV from "constants/env";

const companyId = () => localStorage.getItem("companyId") || ENV.COMPANY_ID;
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getEarningCodes = async () => {
    const res = (await axiosInstance.get(`/companies/${companyId()}/earning_codes`, {
        params: { active: true, page: 1, pageSize: 100 },
    })).data;
    return unwrap(res);
};

export const createEarningCode = async (payload) => {
    return (await axiosInstance.post(`/companies/${companyId()}/earning_codes`, payload)).data;
};

export const updateEarningCode = async ({ codeId, ...payload }) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/earning_codes/${codeId}`, payload)).data;
};

export const deleteEarningCode = async (codeId) => {
    return (await axiosInstance.delete(`/companies/${companyId()}/earning_codes/${codeId}`)).data;
};
